import { TimelineSection } from '../section-listing.model';

export class TargetSection extends TimelineSection {
  targetType: string;
  currentTarget: string;
  assessmentTarget: number;
  targetComments: string;
}
